<template>
    <DForm @submit.prevent="submitForm">
        <DFormRow
            :label="__('settings.netsuite_settings.form.url')"
            :is-required="true"
            :error="errorsData.url"
            :hint="__('settings.netsuite_settings.form.url_hint')"
        >
            <DInput
                id="url"
                v-model="form.url"
                :placeholder="__('settings.netsuite_settings.form.url')"
                :is-valid="isFormFieldValid('url')"
                maxlength="128"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.netsuite_settings.form.realm')"
            :is-required="true"
            :error="errorsData.realm"
            :hint="__('settings.netsuite_settings.form.realm_hint')"
        >
            <DInput
                id="realm"
                v-model="form.realm"
                :placeholder="__('settings.netsuite_settings.form.realm')"
                :is-valid="isFormFieldValid('realm')"
                maxlength="11"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.netsuite_settings.form.token_secret')"
            :is-required="netSuiteSettings === null"
            :error="errorsData.token_secret"
            :hint="__('settings.netsuite_settings.form.token_secret_hint')"
        >
            <DInput
                id="token_secret"
                v-model="form.token_secret"
                type="password"
                :placeholder="__('settings.netsuite_settings.form.token_secret')"
                :is-valid="isFormFieldValid('token_secret')"
                maxlength="64"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.netsuite_settings.form.access_token')"
            :is-required="true"
            :error="errorsData.access_token"
            :hint="__('settings.netsuite_settings.form.access_token_hint')"
        >
            <DInput
                id="access_token"
                v-model="form.access_token"
                :placeholder="__('settings.netsuite_settings.form.access_token')"
                :is-valid="isFormFieldValid('access_token')"
                maxlength="64"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.netsuite_settings.form.consumer_secret')"
            :is-required="netSuiteSettings === null"
            :error="errorsData.consumer_secret"
            :hint="__('settings.netsuite_settings.form.consumer_secret_hint')"
        >
            <DInput
                id="consumer_secret"
                v-model="form.consumer_secret"
                type="password"
                :placeholder="__('settings.netsuite_settings.form.consumer_secret')"
                :is-valid="isFormFieldValid('consumer_secret')"
                maxlength="64"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.netsuite_settings.form.consumer_key')"
            :is-required="true"
            :error="errorsData.consumer_key"
            :hint="__('settings.netsuite_settings.form.consumer_key_hint')"
        >
            <DInput
                id="consumer_key"
                v-model="form.consumer_key"
                :placeholder="__('settings.netsuite_settings.form.consumer_key')"
                :is-valid="isFormFieldValid('consumer_key')"
                maxlength="64"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.netsuite_settings.form.adyen_in_transit_account')"
            :is-required="true"
            :error="errorsData.adyen_in_transit_account"
            :hint="__('settings.netsuite_settings.form.adyen_in_transit_account_hint')"
        >
            <DInput
                id="adyen_in_transit_account"
                v-model="form.adyen_in_transit_account"
                :placeholder="__('settings.netsuite_settings.form.adyen_in_transit_account')"
                :is-valid="isFormFieldValid('adyen_in_transit_account')"
                maxlength="64"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.netsuite_settings.form.subsidiary')"
            :is-required="true"
            :error="errorsData.subsidiary"
            :hint="__('settings.netsuite_settings.form.subsidiary_hint')"
        >
            <DInput
                id="subsidiary"
                v-model="form.subsidiary"
                :placeholder="__('settings.netsuite_settings.form.subsidiary')"
                :is-valid="isFormFieldValid('subsidiary')"
                maxlength="64"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.netsuite_settings.form.system_id')"
            :is-required="true"
            :error="errorsData.system_id"
            :hint="__('settings.netsuite_settings.form.system_id_hint')"
        >
            <DInput
                id="system_id"
                v-model="form.system_id"
                :placeholder="__('settings.netsuite_settings.form.system_id')"
                :is-valid="isFormFieldValid('system_id')"
                maxlength="64"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.netsuite_settings.form.crm_id_prefix')"
            :error="errorsData.crm_id_prefix"
            :hint="__('settings.netsuite_settings.form.crm_id_prefix_hint')"
        >
            <DInput
                id="crm_id_prefix"
                v-model="form.crm_id_prefix"
                :placeholder="__('settings.netsuite_settings.form.crm_id_prefix')"
                :is-valid="isFormFieldValid('crm_id_prefix')"
                maxlength="20"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.netsuite_settings.form.dunning_fee_account')"
            :is-required="true"
            :error="errorsData.dunning_fee_account"
            :hint="__('settings.netsuite_settings.form.dunning_fee_account_hint')"
        >
            <DInput
                id="dunning_fee_account"
                v-model="form.dunning_fee_account"
                :placeholder="__('settings.netsuite_settings.form.dunning_fee_account')"
                :is-valid="isFormFieldValid('dunning_fee_account')"
                maxlength="10"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.netsuite_settings.form.dunning_fee_department')"
            :is-required="true"
            :error="errorsData.dunning_fee_department"
            :hint="__('settings.netsuite_settings.form.dunning_fee_department_hint')"
        >
            <DInput
                id="dunning_fee_department"
                v-model="form.dunning_fee_department"
                :placeholder="__('settings.netsuite_settings.form.dunning_fee_department')"
                :is-valid="isFormFieldValid('dunning_fee_department')"
                maxlength="10"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.netsuite_settings.form.sync_api_customer')"
            :is-required="true"
            :error="errorsData.sync_api_customer"
            :hint="__('settings.netsuite_settings.form.sync_api_customer_hint')"
        >
            <DSwitch
                id="send_sync_api_customer"
                v-model="form.sync_api_customer"
                color="success"
                variant="3d"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.netsuite_settings.form.sync_api_invoice')"
            :is-required="true"
            :error="errorsData.sync_api_invoice"
            :hint="__('settings.netsuite_settings.form.sync_api_invoice_hint')"
        >
            <DSwitch
                id="send_sync_api_invoice"
                v-model="form.sync_api_invoice"
                color="success"
                variant="3d"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.netsuite_settings.form.sync_api_payment')"
            :is-required="true"
            :error="errorsData.sync_api_payment"
            :hint="__('settings.netsuite_settings.form.sync_api_payment_hint')"
        >
            <DSwitch
                id="sync_api_payment"
                v-model="form.sync_api_payment"
                color="success"
                variant="3d"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.netsuite_settings.form.sync_api_transaction_export')"
            :is-required="true"
            :error="errorsData.sync_api_transaction_export"
            :hint="__('settings.netsuite_settings.form.sync_api_transaction_export_hint')"
        >
            <DSwitch
                id="sync_api_transaction_export"
                v-model="form.sync_api_transaction_export"
                color="success"
                variant="3d"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.netsuite_settings.form.sync_api_credit_note')"
            :is-required="true"
            :error="errorsData.sync_api_credit_note"
            :hint="__('settings.netsuite_settings.form.sync_api_credit_note_hint')"
        >
            <DSwitch
                id="send_sync_api_credit_note"
                v-model="form.sync_api_credit_note"
                color="success"
                variant="3d"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.netsuite_settings.form.sync_api_debt_loss')"
            :is-required="true"
            :error="errorsData.sync_api_debt_loss"
            :hint="__('settings.netsuite_settings.form.sync_api_debt_loss_hint')"
        >
            <DSwitch
                id="sync_api_debt_loss"
                v-model="form.sync_api_debt_loss"
                color="success"
                variant="3d"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.netsuite_settings.form.payment_reference')"
            :is-required="true"
            :error="errorsData.payment_reference"
            :hint="__('settings.netsuite_settings.form.payment_reference_hint')"
        >
            <DSelect
                id="payment_reference"
                v-model="form.payment_reference"
                :options="paymentReferenceOptions"
            />
        </DFormRow>
        <DRow>
            <DCol sm="4" />
            <DCol sm="4">
                <div
                    v-if="isConnectionEstablished"
                    class="connection-successful"
                >
                    {{ __('settings.netsuite_settings.connection_successful') }}
                </div>
                <div
                    v-if="isConnectionEstablished !== null && !isConnectionEstablished"
                    class="connection-failed"
                >
                    {{ __('settings.netsuite_settings.connection_unsuccessful') }}
                </div>
            </DCol>
            <DCol
                sm="4"
                class="check-database-connection-btn"
            >
                <DButton
                    icon="lan-connect"
                    :label="__('settings.netsuite_settings.check_connection')"
                    :disabled="isInLoadingState"
                    @click="checkConnection"
                />
            </DCol>
        </DRow>
        <DFormControls
            v-if="canShowSaveButton"
            :dirty="form.isDirty"
            @submit="submitForm"
        />
        <DConnectionErrorModal
            :show-modal="connectionException !== null"
            :exception="connectionException"
            @close-modal="closeErrorCheckModal"
        />
    </DForm>
</template>

<script setup>
import DConnectionErrorModal from '~@/Components/Common/DConnectionErrorModal'
import { useForm } from '@inertiajs/vue3'

import { route } from '~@/Composables/route'
import { ref, watch, computed } from 'vue'

const props = defineProps({
    netSuiteSettings: {
        type: Object,
        default: () => { return {} }
    },
    paymentReferenceOptions: {
        type: Array,
        default: () => []
    },
    errors: {
        type: Object,
        default: () => { return {} }
    }
})

const emit = defineEmits(['form-submitted'])

const form = useForm({
    url: props.netSuiteSettings?.url ?? null,
    realm: props.netSuiteSettings?.realm ?? null,
    token_secret: props.netSuiteSettings?.token_secret ?? null,
    access_token: props.netSuiteSettings?.access_token ?? null,
    consumer_secret: props.netSuiteSettings?.consumer_secret ?? null,
    consumer_key: props.netSuiteSettings?.consumer_key ?? null,
    adyen_in_transit_account: props.netSuiteSettings?.adyen_in_transit_account ?? null,
    subsidiary: props.netSuiteSettings?.subsidiary ?? null,
    system_id: props.netSuiteSettings?.system_id ?? null,
    crm_id_prefix: props.netSuiteSettings?.crm_id_prefix ?? null,
    dunning_fee_account: props.netSuiteSettings?.dunning_fee_account ?? null,
    dunning_fee_department: props.netSuiteSettings?.dunning_fee_department ?? null,
    finance_system: 'netsuite',
    sync_api_customer: props.netSuiteSettings?.sync_api_customer ?? false,
    sync_api_invoice: props.netSuiteSettings?.sync_api_invoice ?? false,
    sync_api_credit_note: props.netSuiteSettings?.sync_api_credit_note ?? false,
    sync_api_payment: props.netSuiteSettings?.sync_api_payment ?? false,
    payment_reference: props.netSuiteSettings?.payment_reference ?? 'invoice_payment_reference',
    sync_api_debt_loss: props.netSuiteSettings?.sync_api_debt_loss ?? false,
    sync_api_transaction_export: props.netSuiteSettings?.sync_api_transaction_export ?? false
})

const isConnectionEstablished = ref(null)
const connectionException = ref(null)
const credentialsAreValid = ref(false)
const errorsData = ref(props.errors)
const hasFormChanged = ref(false)
const previousForm = ref(JSON.stringify(form))

watch(() => props.errors, (newErrors, oldErrors) => {
    errorsData.value = newErrors
})

watch(form, () => {
    const currentForm = JSON.stringify(form)
    setHasFormChanged(currentForm !== previousForm.value)
    previousForm.value = currentForm
}, { deep: true })

function checkConnection () {
    errorsData.value = {}
    connectionException.value = null
    window.axios.post(route('settings.finance-system-settings.check-netsuite', form))
        .then(function () {
            setConnectionEstablished(true)
            setHasFormChanged(false)
            credentialsAreValid.value = true
        })
        .catch(function (error) {
            setConnectionEstablished(false)
            credentialsAreValid.value = false

            if (error.response.data.errors !== undefined) {
                errorsData.value = error.response.data.errors
                for (const key in errorsData.value) {
                    if (typeof errorsData.value[key] === 'object') {
                        errorsData.value[key] = errorsData.value[key][0]
                    }
                }
            }

            if (error?.response.data.exception !== undefined) {
                connectionException.value = error.response.data.exception
            }
        })
}

function closeErrorCheckModal () {
    connectionException.value = null
}

function submitForm () {
    setConnectionEstablished(null)
    emit('form-submitted', form)
}

function setConnectionEstablished (value) {
    isConnectionEstablished.value = value
}

function setHasFormChanged (value) {
    hasFormChanged.value = value
}

const canShowSaveButton = computed(() => {
    return isConnectionEstablished.value && !hasFormChanged.value
})

</script>

<style lang="scss" scoped>
.check-database-connection-btn {
    text-align: right;
    padding-bottom: 25px;
}
.connection-successful {
    color: green;
}
.connection-failed {
    color: red;
}
</style>
